// Library dependencies
import { zodResolver } from "@hookform/resolvers/zod";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { toast } from "sonner";

// Internal dependencies
import { AUTH_ERRORS } from "@/constants/auth.errors";
import { loginSchema } from "../schemas/auth.schema";

// Types
import { LoginInput } from "@/types/auth.types";
import { useForgotPassword } from "../queries/auth.create.queries";

export const useForgotPasswordUser = () => {
  const [error, setError] = useState<string | null>(null);
  const { mutateAsync: forgotPassword, isPending } = useForgotPassword();

  const form = useForm<Omit<LoginInput, "password">>({
    resolver: zodResolver(loginSchema.omit({password: true})),
    defaultValues: {
      email: "",
    },
  });

  const onSubmit = async (data: Omit<LoginInput, "password">) => {
    setError(null);

    try {
      const response = await forgotPassword(data);

      if (response.success) {
        toast.success("Successfully sent reset link!");
        form.reset();
        return;
      }
    } catch (error) {
      setError(AUTH_ERRORS.FORGOT_PASSWORD_FAILED);
    }
  };

  return {
    form,
    onSubmit,
    isLoading: isPending,
    error,
  };
};
